import { Form as FinalForm, Field } from "react-final-form";
import { Form, Button, Grid, Segment } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { ITenantFilter } from "../../../app/models/report";
import SelectInputOnSearchChange from "../../../app/common/form/SelectInputOnSearchChange";
import DateInput from "../../../app/common/form/DateInput";
import { useContext, useState } from "react";
import { Role } from "../../../app/util/role";
import React from "react";

const TenantFilter = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);  
  const { user } = rootStore.userStore;
  const {
    tenantFilter,
    btFilterTenant,
    getBrokersAutocomplete,
    brokersAutocomplete,
    setTenantFilter,
    getTenantsAutocomplete,
    tenantsAutocomplete,
  } = rootStore.reportStore;

  const [tenantFilterForm] = useState<ITenantFilter>({
    brokerId: tenantFilter.brokerId,
    tenantId: tenantFilter.tenantId,
    dateFrom: tenantFilter.dateFrom,
    dateTo: tenantFilter.dateTo,
  });

  const handleFinalFormSubmit = (values: any) => {
    setTenantFilter(values);
  };

  const handleBroker = async (value: any) => {
    getBrokersAutocomplete(value);
  };

  const handleTenant = async (value: any) => {
    getTenantsAutocomplete(value);
  };

  return (
    <Segment className="grayborder">
      <FinalForm
        initialValues={tenantFilterForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <div className="filter">
              <Grid relaxed doubling columns={2}>
                <Grid.Row columns={3}>
                {user?.role === Role.Sudo && (
                  <Grid.Column>
                    <label>Agente</label>
                    <Field
                      name="brokerId"
                      value={tenantFilterForm.brokerId}
                      component={SelectInputOnSearchChange}
                      search={true}
                      autoComplete="off"
                      options={brokersAutocomplete}
                      onSearchChange={handleBroker}
                    />
                  </Grid.Column>)}
                  <Grid.Column>
                    <label>Cliente</label>
                    <Field
                      name="tenantId"
                      value={tenantFilterForm.tenantId}
                      component={SelectInputOnSearchChange}
                      search={true}
                      autoComplete="off"
                      options={tenantsAutocomplete}
                      onSearchChange={handleTenant}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <label>Fecha consumo (dd/mm/yyyy)</label>
                    <Form.Group widths="equal">
                      <Field
                        name="dateFrom"
                        placeholder="desde"
                        value={tenantFilterForm.dateFrom}
                        component={DateInput}
                      />
                      <Field
                        name="dateTo"
                        placeholder="hasta"
                        value={tenantFilterForm.dateTo}
                        component={DateInput}
                      />
                    </Form.Group>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <br />
              <Button
                loading={btFilterTenant}
                disabled={btFilterTenant}
                className="ui primary button filterbutton"
                color="blue"
                type="submit"
                content="Buscar"
              />
            </div>
          </Form>
        )}
      />
    </Segment>
  );
};

export default observer(TenantFilter);
